import { z } from 'zod'

export enum Status {
  active = 'active',
  inactive = 'inactive',
}

export const StatusSchema = z.nativeEnum(Status)
